import { render, staticRenderFns } from "./DealerProfile.vue?vue&type=template&id=531eb1d2&scoped=true"
import script from "./DealerProfile.vue?vue&type=script&lang=js"
export * from "./DealerProfile.vue?vue&type=script&lang=js"
import style0 from "./DealerProfile.vue?vue&type=style&index=0&id=531eb1d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531eb1d2",
  null
  
)

export default component.exports